if (!customElements.get('abo-preview-modal')) {
  customElements.define(
    'abo-preview-modal',
    class AboPreviewModal extends DrawerComponent {
      constructor() {
        super();
        this._classes = { loaded: 'abo-preview-loaded' };
      }

      connectedCallback() {
        super.connectedCallback();
        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          () => {
            if (this.open) this.hide();
          }
        );
      }

      get selector() {
        return '.abo-preview__content';
      }

      get sourceSelector() {
        return '#MainProduct-quick-view__content';
      }

      get requiresBodyAppended() {
        return !(Shopify.designMode && this.closest('.section-group-overlay-abo-preview'));
      }

      shouldBeShown() {
        return typeof this.getSectionId() === 'string';
      }

      prepareToShow() {
        super.prepareToShow();
        this.load();
      }

      onButtonClick(event) {
        event.preventDefault();
        this.hide();
      }

      handleAfterHide() {
        super.handleAfterHide();
        const body = this.querySelector(this.selector);
        if (body) body.innerHTML = '';
        this.classList.remove(this._classes.loaded);
      }

      getSectionId() {
        let sectionId = FoxTheme.AboPreviewSectionId || false;
        if (!sectionId) {
          const el = document.querySelector('.section-group-overlay-abo-preview');
          if (el) sectionId = FoxTheme.utils.getSectionId(el);
          FoxTheme.AboPreviewSectionId = sectionId;
        }
        return sectionId;
      }

      load() {
        const body = this.querySelector(this.selector);
        const sectionId = this.getSectionId();
        const base = this.dataset.productUrl.split('?')[0];
        const variant = this.dataset.variantId;
        const url = `${base}?section_id=${sectionId}${variant ? `&variant=${variant}` : ''}`;

        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const source = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector(this.sourceSelector);
            if (!source) return;

            this.setInnerHTML(body, source.content.cloneNode(true));
            FoxTheme.a11y.trapFocus(this, this.focusElement);
            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            setTimeout(() => this.classList.add(this._classes.loaded), 300);
            document.dispatchEvent(
              new CustomEvent('abo-preview:loaded', { detail: { productUrl: this.dataset.productUrl } })
            );
          })
          .catch((e) => console.error(e));
      }

      setInnerHTML(element, content) {
        element.innerHTML = '';
        element.appendChild(content);
        element.querySelectorAll('script').forEach((oldScript) => {
          const newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach((a) => newScript.setAttribute(a.name, a.value));
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      }

      disconnectedCallback() {
        super.disconnectedCallback();
        this.cartUpdateUnsubscriber?.();
        this.handleAfterHide();
      }
    }
  );
}

if (!customElements.get('abo-card-gate')) {
  customElements.define(
    'abo-card-gate',
    class AboCardGate extends HTMLElement {
      connectedCallback() {
        this.planVariants = (this.dataset.planVariants || '').split(',').filter(Boolean);
        this.form = this.dataset.formId
          ? document.getElementById(this.dataset.formId)
          : this.querySelector('form') || this.closest('form');
        this.variantInput = this.form?.querySelector('[name="id"]');

        this.form?.addEventListener('submit', this.onSubmit.bind(this), true);
      }

      onSubmit(event) {
        const id = this.variantInput ? String(this.variantInput.value) : '';
        if (!this.planVariants.includes(id)) return;
        const modal = this.modal || (this.dataset.modalId && document.getElementById(this.dataset.modalId));
        if (!modal || !document.querySelector('.section-group-overlay-abo-preview')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        modal.dataset.variantId = id;
        if (typeof modal.show === 'function') modal.show();
        else modal.setAttribute('open', '');
      }
    }
  );
}
